module.exports = __webpack_public_path__ + "img/icon_sub_02.93577272.jpg";